import type { Dashboardv99990101Api } from '@sequencehq/api/dashboard/v99990101'

import type { SimpleTask } from 'Automations/nodeDefinitions/conductor'
import { taskExecutor } from '../analyseAutomation/taskExecutor'
import { executorVersion } from './executorVersion'

type Body = Dashboardv99990101Api.PostInvokeTaskExecutor.Body
type SimulatableExecutor =
  Dashboardv99990101Api.PostInvokeTaskExecutor.SimulatableExecutor

/**
 * The request we send to run one task. The analysis only keeps
 * `get_sequence_data` tasks, and every executor that task type runs is one the
 * backend will invoke for us, so the only thing left to check is that the task
 * names an executor at all.
 */
export const invocationBody = ({
  task,
  data
}: {
  task: SimpleTask
  data: Record<string, unknown>
}): Body | undefined => {
  const executor = taskExecutor(task)
  if (!executor) return undefined

  return {
    taskExecutorConfiguration: {
      executor: executor as SimulatableExecutor,
      version: executorVersion(task)
    },
    data
  }
}
